"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Link = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.793 6.207l.078.089A1.014 1.014 0 018.447 7.72l-.088-.079A2.028 2.028 0 005.6 7.538l-.11.103-2.869 2.869A2.028 2.028 0 005.38 13.48l.111-.103 1.434-1.434a1.014 1.014 0 011.513 1.345l-.078.089-1.435 1.434a4.056 4.056 0 01-5.876-5.59l.14-.146 2.868-2.869a4.056 4.056 0 015.59-.14l.147.14zm5.019-5.019a4.056 4.056 0 01.14 5.59l-.14.146-2.868 2.869a4.056 4.056 0 01-5.59.14l-.147-.14-.078-.089A1.014 1.014 0 017.553 8.28l.088.079c.757.756 1.96.79 2.758.103l.11-.103 2.869-2.869A2.028 2.028 0 0010.62 2.52l-.111.103-1.434 1.434a1.014 1.014 0 01-1.513-1.345l.078-.089 1.435-1.434a4.056 4.056 0 015.736 0z",
  fill: "#ACB3BE"
}));

var _default = Link;
exports.default = _default;